import Button from "Components/Button";
import FlexRow from "Components/FlexRow";
import Modal from "Components/Modal";
import Space from "Components/Space";
import {useTranslation} from "react-i18next";
import {useChangeTagsForMultipleOrders} from "../../../Apis/InvoicesApi";
import {IOverviewOrderDto} from "../../../Apis/Models/IOrderDto";
import useToasts from "../../../Hooks/UseToasts";
import React from "react";
import {useForm} from "react-hook-form";
import ControlledSelect from "../../../Components/Select/ControlledSelect";
import Select from "Components/Select";
import useFilteredList from "../../../Hooks/UseFilteredList";
import {useTags} from "../../../Apis/TagApi";

type FormData = {
    addTags: number[];
    removeTags: number[];
}

interface Props {
    visible: boolean;
    toggleVisible: () => void;
    onSuccess?: () => void;
    orders: IOverviewOrderDto[];
}
const ChangeOrderTagsModal = (props: Props) => {

    const { t } = useTranslation();

    const { showSuccessToast } = useToasts();
    const { control, handleSubmit, reset } = useForm<FormData>();

    const { mutateAsync, isLoading } = useChangeTagsForMultipleOrders();

    const { data: tags } = useTags({ includeAll: true });

    const [ filteredRemoveTags, setFilteredRemoveTags ] = useFilteredList(tags?.items ?? [], x => [x.name]);
    const [ filteredAddTags, setFilteredAddTags ] = useFilteredList(tags?.items ?? [], x => [x.name]);

    const changeOrderStatus = async (data: FormData) => {
        await mutateAsync({
            orderIds: props.orders.map(x => x.id),
            addTags: data.addTags,
            removeTags: data.removeTags
        });

        showSuccessToast(t('tagsChanged'));
        
        props.toggleVisible();
        props.onSuccess && props.onSuccess();
        reset();
    }

    return (
        <Modal title={t('changeOrderTags')} visible={props.visible} onCancel={() => props.toggleVisible()} modalStyle={{overflow: 'visible'}}>
            <form onSubmit={handleSubmit(changeOrderStatus)}>
                <Space size={"large"}>
                    <ControlledSelect control={control} placeholder={t('addTag')} name={`addTags`} onFilter={setFilteredAddTags} multiple>
                        {filteredAddTags?.map((tag) => <Select.Option key={tag.id} value={tag.id} label={tag.name} />)}
                    </ControlledSelect>

                    <ControlledSelect control={control} placeholder={t('removeTag')} name={`removeTags`} onFilter={setFilteredRemoveTags} multiple>
                        {filteredRemoveTags?.map((tag) => <Select.Option key={tag.id} value={tag.id} label={tag.name} />)}
                    </ControlledSelect>

                    <FlexRow justify={"end"}>
                        <Button type={"secondary"} buttonType={"submit"} loading={isLoading} text={t('changeOrderTags')}/>
                    </FlexRow>
                </Space>
            </form>
        </Modal>
    )
}

export default ChangeOrderTagsModal